var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalReference(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "68EBF62B-B0BB-4F85-A369-8EDFA132BB7A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-386.000000, -3381.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Supporting",
    transform: "translate(360.000000, 3083.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-personal-reference",
    transform: "translate(24.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,13.5081273 21.6661497,14.9382797 21.0683211,16.2205851 L21.9456483,20.4203997 C22.1717499,21.5027609 21.4817519,22.1947627 20.4008029,21.9652452 L16.2068017,21.0747343 C14.9280345,21.6685368 13.502726,22 12,22 Z M15.969584,18.9797791 L19.7713289,19.792589 L18.9745567,15.9783955 L19.2556404,15.3754882 C19.7437575,14.3285071 20,13.1843543 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C13.1801788,20 14.3204475,19.7455645 15.3644751,19.2607647 L15.969584,18.9797791 Z M12,13.5 C11.1715729,13.5 10.5,12.8284271 10.5,12 C10.5,11.1715729 11.1715729,10.5 12,10.5 C12.8284271,10.5 13.5,11.1715729 13.5,12 C13.5,12.8284271 12.8284271,13.5 12,13.5 Z M8,13.5 C7.17157288,13.5 6.5,12.8284271 6.5,12 C6.5,11.1715729 7.17157288,10.5 8,10.5 C8.82842712,10.5 9.5,11.1715729 9.5,12 C9.5,12.8284271 8.82842712,13.5 8,13.5 Z M16,13.5 C15.1715729,13.5 14.5,12.8284271 14.5,12 C14.5,11.1715729 15.1715729,10.5 16,10.5 C16.8284271,10.5 17.5,11.1715729 17.5,12 C17.5,12.8284271 16.8284271,13.5 16,13.5 Z",
    id: "path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalReference);
export default __webpack_public_path__ + "static/media/personal-reference.fb0dced50996488d401479598e8b9fd3.svg";
export { ForwardRef as ReactComponent };